// extracted by mini-css-extract-plugin
export default {"model":"PopUp_model__v6tT6","overlay":"PopUp_overlay__XGChu"};